import { gql } from '@apollo/client'

export const GET_POPULAR_TEAMS = gql`
  query ListPopularTeams {
    listPopularTeams {
      _id
      oImg {
        sText
        sCaption
        sAttribute
        sUrl
      }
      sCountry
      sAltName
      sAbbr
      sTitle
      oSeo {
        sSlug
      }
    }
  }
`
export const GET_TEAM_LIST_WITH_SERIES = gql`
  query listTeamsByPopularSeries {
  listTeamsByPopularSeries {
    aTeams {
      _id
      sTitle
      sAbbr
      oSeo {
        sSlug
      }
      oImg {
        sUrl
        sText
        sCaption
        sAttribute
      }
      sCountryFull
    }
    oSeries {
      _id
      sTitle
    }
  }
}
`

export const TEAM_LIST_WITH_FILTERS = gql`
  query ListTeamsWithFilters($input: listTeamsWithFiltersInput) {
    listTeamsWithFilters(input: $input) {
      _id
      sTitle
      sCountryFull
      sAbbr
      oSeo {
        sSlug
      }
      oImg {
        sAttribute
        sCaption
        sText
        sUrl
      }
    }
  }
`

export const COUNTRIES_LIST = gql`
  query Query {
    listTeamsCountry
  }
`
